import React from 'react'
import { graphql, Link } from 'gatsby'

import ShareSocials from '../components/shareSocials'
import Image from 'gatsby-image'
import { FaArrowLeft } from 'react-icons/fa'

import Layout from '../components/layout'
import Head from '../components/head'
import FromCategory from '../components/FromCategory'
import AddToCart from '../components/addToCart'


export const data = graphql`
  query($url: String!) {
    contentfulProduit(slug: { eq: $url }) {
      title
      slug
      id
      description {
        description
      }
      category {
        name
      }
      price
      pricePromo
      image {
        fluid(maxWidth: 900) {
          src
          ...GatsbyContentfulFluid_withWebp
        }
      }
    }
  }
`

const Product = ({ data }) => {
  return (
    <Layout>
      <Head title={data.contentfulProduit.title} />
      <section className="padding">
        <h1 className="text-center mb-3">{data.contentfulProduit.title}</h1>
        <div className="grid-x grid-margin-x align-top align center">
          <div className="cell large-6">
            <Image fluid={data.contentfulProduit.image.fluid} loading="eager" durationFadeIn={250} />
          </div>
          <div className="cell large-6">
            <h2 className="h4 text-black">{data.contentfulProduit.title}</h2>
            <h3 class="">{data.contentfulProduit.category.name}</h3>
            <div className="text">
              {data.contentfulProduit.description.description}
            </div>
            <div className="price--container mb-2">
              <span
                className={`price ${
                  data.contentfulProduit.pricePromo ? 'price--erased' : ''
                }`}
              >
                {new Intl.NumberFormat('fr-FR', {
                  style: 'currency',
                  currency: 'EUR',
                }).format(data.contentfulProduit.price)}
              </span>
              {data.contentfulProduit.pricePromo && (
                <span className="price price--promo">
                  {new Intl.NumberFormat('fr-FR', {
                    style: 'currency',
                    currency: 'EUR',
                  }).format(data.contentfulProduit.pricePromo)}
                </span>
              )}
            </div>
            <div className="cta-area mb-2">
              <Link className="button primary-dark" to="/catalogue">
                <FaArrowLeft className="mr-1" /> Retour au catalogue
              </Link>
              <AddToCart 
                id={data.contentfulProduit.id}
                price={data.contentfulProduit.price}
                url="babycommerce.netlify.app/catalogue"
                image={data.contentfulProduit.image.fluid.src}
                name={data.contentfulProduit.title}
                buttonText="Ajouter"
              />
            </div>
            <ShareSocials title={data.contentfulProduit.title} />
          </div>
        </div>
      </section>
      <section className="full-width bg-light-gray">
        <div className="grid-container">
          <div className="padding">
            <h2 className="text-center mb-2">
              Autres articles dans la catégorie{' '}
              <em>{data.contentfulProduit.category.name}</em>
            </h2>
            <FromCategory
              categoryName={data.contentfulProduit.category.name}
              currentSlug={data.contentfulProduit.slug}
            />
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Product
